import { render, staticRenderFns } from "./ChangeStatus.vue?vue&type=template&id=1f2714bc&lang=pug&"
import script from "./ChangeStatus.vue?vue&type=script&lang=js&"
export * from "./ChangeStatus.vue?vue&type=script&lang=js&"
import style0 from "./ChangeStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
